// 翻译任务相关类型定义

export type Int64Id = string

// 翻译状态(复用Flutter模型)
export enum TranslateStatus {
  NotStarted = 0,
  Waiting = 1,
  Translating = 2,
  Success = 3,
  Failed = 4
}

// 翻译任务
export interface Task {
  id: string                    // 前端生成的临时ID
  recordId?: Int64Id            // 后端返回的记录ID(可选)
  fileId?: Int64Id              // 上传后的文件ID (用于重试)
  originalFileName: string
  targetLanguage: string
  sourceLanguage?: string       // 可选
  category?: string             // 任务来源分类 (e.g. 'pdf', 'ebook')
  status: 'uploading' | 'translating' | 'completed' | 'failed'
  progress?: number             // 0-100 (可选)
  createdAt: string            // ISO 8601 日期字符串
  downloadUrl?: string         // 完成后的下载链接
  error?: string               // 失败时的错误信息
}

// 语言信息(复用Flutter模型)
export interface LanguageInfo {
  code: string
  name: string
  section: string  // 拼音首字母分组
}

// 翻译限额信息
export interface DocTranslateLimitInfo {
  totalPages: number
  pageList: Array<{
    pages: number
    expireTime: string  // ISO格式
  }>
}

// 文档翻译记录
export interface DocTranslateRecord {
  recordId: Int64Id
  srcFileId: Int64Id
  srcFileName: string
  srcFileDownloadUrl: string
  from: string
  to: string
  translateStatus: TranslateStatus
  downloadUrl: string
  createTime: string  // ISO格式
}

// 文档翻译记录列表
export interface DocTranslateRecordList {
  records: DocTranslateRecord[]
}

// 翻译文件结果
export interface TranslateFileResult {
  recordId: Int64Id
  status: TranslateStatus
  downloadUrl: string
  isEnd: boolean
  pollIntervalMs: number
  progressPercent: number | null
  progressDetail: string
}
